// src/pages/Users/Galleries/components/EmptyState.jsx

import React from "react";
import { FaImages, FaRedo } from "react-icons/fa";

export default function EmptyState({
  title = "Aucun album à afficher",
  description = "Modifiez la recherche, le tri ou l’affichage.",
  onReset,
  resetLabel = "Réinitialiser",
}) {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white p-8 text-center shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-100 text-slate-400 dark:bg-slate-800">
        <FaImages className="text-2xl" />
      </div>

      <h3 className="mt-4 text-xl font-bold text-slate-950 dark:text-white">
        {title}
      </h3>

      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
        {description}
      </p>

      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 text-sm font-bold text-white transition active:scale-95 dark:bg-white dark:text-slate-950"
        >
          <FaRedo />
          {resetLabel}
        </button>
      )}
    </div>
  );
}